import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useQSBuilder from "../../hooks/useQSBuilder";
import { ApplicationSettingsQueryKeys } from "./keys";
import {
  ApplicationSettingsQueryString,
  CreateUpdateApplicationSetting,
} from "../../models/ApplicationSettings/ApplicationSettings";

export default function useApplicationSettingsMutations(
  ids: ApplicationSettingsQueryString
) {
  const queryClient = useQueryClient();
  const buildQS = useQSBuilder();
  const { post, put, del } = useApiHelper();

  const create = useMutation({
    mutationFn: (setting: CreateUpdateApplicationSetting) =>
      post(
        `/applicationsetting${buildQS({
          applicationOrRegistrationId: ids.applicationId || ids.applicationRegistrationId,
        })}`,
        setting
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ApplicationSettingsQueryKeys.byAppOrAppRegId(ids),
      });
    },
  });

  const update = useMutation({
    mutationFn: (updateSetting: CreateUpdateApplicationSetting) =>
      put(`/applicationsetting/${updateSetting.id}`, updateSetting),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ApplicationSettingsQueryKeys.byAppOrAppRegId(ids),
      });
    },
  });

  const remove = useMutation({
    mutationFn: (settingId: string) => del(`/applicationsetting/${settingId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ApplicationSettingsQueryKeys.byAppOrAppRegId(ids),
      });
    },
  });

  return {
    create,
    update,
    remove,
  };
}
